import { ReactNode } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import CookieConsent from '../components/CookieConsent';
import { ChatbotProvider } from '../contexts/ChatbotContext';
import { ModalProvider } from '../contexts/ModalContext';

interface MainLayoutProps {
  children: ReactNode;
}

const MainLayout = ({ children }: MainLayoutProps) => {
  return (
    <ModalProvider>
      <div className="min-h-screen bg-[#36393F] text-white">
        <ChatbotProvider>
          <Navbar />
          <main>{children}</main>
          <Footer />
          <CookieConsent />
        </ChatbotProvider>
      </div>
    </ModalProvider>
  );
};

export default MainLayout; 